import {Grid, makeStyles} from '@material-ui/core';
import {HealthPlanDto, LifePlanDto, Rider} from 'Agent/Policies/api';
import {Benefit} from 'Agent/Policies/models/Policy';
import {getFeatureToggleVariable} from 'feature';
import React from 'react';
import {AllstateCardV2} from 'Shared/components/AllstateCardV2';
import {CardFieldV2} from 'Shared/components/CardFieldV2';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';
import PlanBenefit from './PlanBenefit';
import PlanBenefitLife from './PlanBenefitLife';

export type HealthPlan = HealthPlanDto & {planType: 'health'};
export type LifePlan = LifePlanDto & {planType: 'life'};

type PlanInformationProps = {
  policyPlan: HealthPlan | LifePlan;
  eisFlag: boolean;
  sourceName?: string;
  benefits?: Benefit[];
  riders?: Rider[];
};

const usePlanInformationStyles = makeStyles(_theme => ({
  container: {
    justifyContent: 'flex-start',
    margin: '0',
    padding: '1rem',
    width: '100%',
    borderBottom: '1px solid #ccc',
  },
  separator: {
    border: '1.5px solid #ccc',
    width: '95%',
    '&:last-of-type': {
      display: 'none',
    },
  },
}));

export const PlanInformation = (props: PlanInformationProps) => {
  const {policyPlan, sourceName,riders} = props;
  const {POLICY_BENEFIT} = getFeatureToggleVariable();
  const styles = usePlanInformationStyles();
    const planValue =
    props.eisFlag && policyPlan.planType === 'life'
      ? 'Group Whole Life'  
:policyPlan.commonPlan;
  return (
    <AllstateCardV2 title="Plan Information">
      <Grid container spacing={3} className={styles.container}>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Plan" value={planValue} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Plan Code" value={policyPlan.planCode} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Description" value={policyPlan.planDescription} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Coverage Type" value={policyPlan.coverageType} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardFieldV2 name="Effective Date" value={toFormattedDateAsUTC(policyPlan.effectiveDate)} />
        </Grid>

        {policyPlan.planType === 'life' && (
          <Grid item xs={12} sm={6} md={3}>
            <CardFieldV2 name="Insurance Amount" value={toMoneyValue(policyPlan.amtOfInsurance)} />
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={3}>
          {!props.eisFlag && (sourceName === 'GROUP' || sourceName === 'LIFE') ? (
            <CardFieldV2 name="Termination Date" value={toFormattedDateAsUTC(policyPlan.terminationDate)} />
          ) : (
            <CardFieldV2 name="Issue Age" value={policyPlan.issueAge} />
          )}
        </Grid>

        {policyPlan.planType === 'health' && !props.eisFlag && (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <CardFieldV2 name="Units" value={policyPlan.units} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardFieldV2 name="Elimination Period Accident" value={policyPlan.eliminationPeriodAccident} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardFieldV2 name="Elimination Period Sickness" value={policyPlan.eliminationPeriodSickness} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              {<CardFieldV2 name="Benefit Period Accident" value={policyPlan.benefitPeriodAccident} />}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardFieldV2 name="Benefit Period Sickness" value={policyPlan.benefitPeriodSickness} />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CardFieldV2 name="Commission Phase" value={policyPlan.commissionPhase} />
            </Grid>
          </>
        )}
      </Grid>

      {POLICY_BENEFIT && props.eisFlag && Array.isArray(props.benefits) && <PlanBenefit benefits={props.benefits} />}
      {'riders' in props.policyPlan && props.eisFlag && policyPlan.planType === 'life' &&  <PlanBenefitLife riders={props.policyPlan.riders} />}
    </AllstateCardV2>
  );
};
